import { IField, getV2ValueWP, tryParseJSON } from '@eventr/common'
import { SelectInputField } from '@eventr/common-storybook'
import { useSignal } from '@preact/signals-react'
import { useCallback } from 'react'
import { IEditComponent } from '../../../data/Data'
import { useBoundStore } from '../../../state/bound.store'
import { useFormatValue } from '../../../v2/hooks/useFormatValue'
import { ComponentFinderEdit } from '../componentFinderEdit'
import { useEditSectionContext } from '../editSectionProvider'

interface IArrayFinderEditProps {
    options: IEditComponent
    field: IField
    _id?: string
}
export interface IExpression {
    operator: '===' | '!==' | '>' | '<' | '>=' | '<=' | 'any'
    param1: string
    param2: string
}

export const ArrayFinderEdit = ({
    options,
    _id,
    field,
}: IArrayFinderEditProps) => {
    const { formatValue } = useFormatValue()
    const wpUser = useBoundStore((s) => s.wpUser)
    const { getValue } = useEditSectionContext()

    const value = useCallback(() => {
        const initFieldValue = getValue(field, _id)

        if (initFieldValue) {
            if (options.settings) {
                const { operator, param1, param2 } = options.settings

                switch (operator) {
                    case 'any':
                        return initFieldValue.filter((v: any) => {
                            const path = param1.split('.')
                            const valueParent = getV2ValueWP(path[0], v)
                            const parsed = tryParseJSON(valueParent, [])
                            return parsed.some((v: any) => {
                                return (
                                    v[path[1]] ===
                                    getV2ValueWP(param2, v, wpUser)
                                )
                            })
                        })
                    case '===':
                        return initFieldValue.filter((v: any) => {
                            return (
                                (
                                    getV2ValueWP(param1, v, wpUser) || ''
                                ).toString() ===
                                (
                                    getV2ValueWP(param2, v, wpUser) || ''
                                ).toString()
                            )
                        }) as []
                    case '!==':
                        return initFieldValue.filter(
                            (v: any) =>
                                (
                                    getV2ValueWP(param1, v, wpUser) || ''
                                ).toString() !==
                                (
                                    getV2ValueWP(param2, v, wpUser) || ''
                                ).toString()
                        ) as []
                    default:
                        return []
                }
            } else {
                return initFieldValue as []
            }
        }
        return []
    }, [getValue])

    const selectedId = useSignal<string | null>(null)

    if (value() && value().length > 1 && !selectedId.value) {
        selectedId.value = value().sort((a, b) => {
            return a[options.multiBooking?.params?.[0] ?? ''] >
                b[options.multiBooking?.params?.[0] ?? '']
                ? 1
                : -1
        })[0]._id
    }

    return (
        <>
            {value().length > 1 && (
                <SelectInputField
                    defaultValue={selectedId.value}
                    data={value()
                        .sort((a: any, b: any) => {
                            return a[options.multiBooking?.params?.[0] ?? ''] >
                                b[options.multiBooking?.params?.[0] ?? '']
                                ? 1
                                : -1
                        })
                        .map((option: any) => {
                            return {
                                displayName: options.multiBooking?.params
                                    .map((param) => {
                                        return formatValue(
                                            option[param],
                                            options.multiBooking?.format ?? ''
                                        )
                                    })
                                    .join(' - '),
                                id: option._id,
                            }
                        })}
                    onChange={(e) => {
                        selectedId.value = e.target.value as string
                    }}
                />
            )}
            {(selectedId.value
                ? value().filter((val: any) => {
                    return val._id === selectedId.value
                })
                : value()
            ).map((v: any, i: number) => {
                return options.components?.map(
                    (option: IEditComponent, index: number) => {
                        return (
                            <div key={i + '.' + index}>
                                <ComponentFinderEdit
                                    _id={v._id}
                                    editComponent={option}
                                />
                            </div>
                        )
                    }
                )
            })}
        </>
    )
}
